import { FlexContainer, Layout, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { FRONT_PLANS, plansNameMapping } from 'Constants/plans';
import { CustomerType } from 'Types/common';
import Service from './component/Service';
import { services } from './utils';

const Services = ({ subscription }: { subscription: CustomerType }): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);
  const activePlan = plansNameMapping(subscription?.activePlan?.name);

  return (
    <Layout.Wrap size="M">
      <FlexContainer direction="column" gap="dimension_24">
        <Text type="paragraphs" size="M_L_S" color="dark">
          {t('Subscription.services.title', {
            context: activePlan !== FRONT_PLANS.BASIC && 'hasSubscription',
          })}
        </Text>
        <FlexContainer wrap="wrap" gap="dimension_16">
          {services[activePlan].map(
            service => service.isAvailable?.() && <Service key={service.title} {...service} />
          )}
        </FlexContainer>
      </FlexContainer>
    </Layout.Wrap>
  );
};

export default Services;
